import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import { Formik } from "formik";
import Fuse from "fuse.js";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { object, string } from "yup";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { AddRoleRequest, GetRolesResponse } from "../../models/role.model";
import { getRoles } from "../../redux/permissions/permissonSlice";
import { AddRole, GetRoles } from "../../services/role.service";
import RolePermissionTableRows from "./components/RolePermissionTableRows";

const columns = [
  { id: 0, title: "ردیف" },
  {
    id: 1,
    title: "عنوان نقش سازمانی",
  },
  {
    id: 2,
    title: "عنوان انگلیسی",
  },
  {
    id: 3,
    title: "تاریخ ایجاد",
  },
  {
    id: 4,
    title: "کاربر ایجاد کننده",
  },
  {
    id: 5,
    title: "تاریخ ویرایش",
  },
  {
    id: 6,
    title: "کاربر ویرایش کننده",
  },
];
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },

  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
}));

const editReportValidationSchema = object().shape({
  title: string()
    .ensure()
    .required("لطفا نام فارسی را وارد نمایید")
    .max(150, "نام فارسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  name: string()
    .ensure()
    .required("لطفا نام انگلیسی را وارد نمایید")
    .max(150, "نام انگلیسی نباید بیش از ۱۵۰ کاراکتر باشد"),
});

const RolePermissionList = () => {
  const [roles, setRoles] = useState<GetRolesResponse[]>([]);
  const [openAddRoleModal, setOpenAddRoleModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const updateRoles = useSelector((state: any) => state.roles);
  const history = useHistory<{ roleId: number }>();

  const initialValues: AddRoleRequest = {
    title: "",
    name: "",
  };

  const { mutate: GetRolesMutate } = useMutation(GetRoles, {
    onSuccess: (data: GetRolesResponse[]) => {
      if (data) {
        setRoles(data);
        dispatch(
          getRoles({
            roles: data,
          })
        );
      }
    },
    onError: () => {},
  });

  const { mutate: AddRoleMutate } = useMutation(AddRole, {
    onSuccess: (data: { id: number }) => {
      if (data) {
        setOpenAddRoleModal(false);
        GetRolesMutate();
        history.push({
          pathname: "/RolePermissionTabs",
          state: { roleId: data.id },
        });
        window.localStorage.setItem("RoleId", String(data.id));
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetRolesMutate();
  }, [updateRoles.update]);

  const handleAddRole = (values: AddRoleRequest) => {
    AddRoleMutate(values);
    window.localStorage.setItem(
      "RoleNameTitle",
      JSON.stringify({ title: values.title, name: values.name })
    );
  };

  const fuse = new Fuse(roles, {
    keys: ["title", "name", "creatorUserFullName", "modifierUserFullName"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const titleResults = searchTerm ? results.map((title) => title.item) : roles;

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };
  return (
    <>
      <Grid container gap={"20px"}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              color={"#28A745"}
              fontWeight={"bold"}
              padding={"0.5rem"}
              borderRadius={"5px"}
              sx={{
                cursor: "pointer",
                width: "fit-content",
                "&: hover": { color: "#fff", background: "#28A745" },
              }}
              onClick={() => {
                setOpenAddRoleModal(true);
              }}
            >
              <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
              افزودن نقش سازمانی
            </Typography>
            <span
              style={{
                marginLeft: "2vh",
                marginRight: "2vh",
                background: "#CFD8DC",
                height: "3vh",
                width: "2px",
              }}
            ></span>
            <Paper
              elevation={0}
              style={{
                border: "1px solid #DAE0E4",
                display: "flex",
                borderRadius: "5px",
                height: "35px",
                width: "20vw",
              }}
              square={true}
            >
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  paddingX: "16px",
                  height: "30px !important",
                }}
                placeholder="جستجو"
                onChange={handleSearchInput}
              />

              <IconButton
                type="button"
                sx={{ color: "#9AAFC4" }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper} sx={{ maxHeight: "80vh" }}>
            <Table
              stickyHeader
              sx={{
                minWidth: { xs: 0, sm: 0, md: 700, lg: 900 },
              }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  {columns.length > 0 &&
                    columns.map((column) => (
                      <StyledTableCell align="center">
                        {column.title}
                      </StyledTableCell>
                    ))}
                </TableRow>
              </TableHead>

              <TableBody
                sx={{
                  outline: "1px solid #DAE0E4",
                }}
              >
                {titleResults?.map((role: GetRolesResponse, index) => (
                  <RolePermissionTableRows role={role} index={index} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {/* add role modal */}
        <div>
          <Modal
            open={openAddRoleModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={deactiveUserStyle}>
              <Grid
                container
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"center"}
                gap={"1rem"}
              >
                <Typography
                  component={"p"}
                  display={"block"}
                  textAlign={"center"}
                  fontWeight={"bold"}
                  //   marginY={"3rem"}
                  fontSize={"14px"}
                  color={"#1D4A87"}
                >
                  افزودن نقش سازمانی
                </Typography>
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleAddRole}
                  validateOnMount={true}
                  validationSchema={editReportValidationSchema}
                >
                  {({
                    handleSubmit,
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid
                        container
                        gap={"1rem"}
                        marginTop={"15px"}
                        maxWidth={"400px"}
                      >
                        <Grid item xs={12}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام فارسی"}
                            label={"نام فارسی"}
                            required={true}
                            name={"title"}
                            id={"title"}
                            value={values.title}
                            helperText={touched.title ? errors.title : ""}
                            error={touched.title && Boolean(errors.title)}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام انگلیسی"}
                            label={"نام انگلیسی"}
                            required={true}
                            name={"name"}
                            id={"name"}
                            value={values.name}
                            helperText={touched.name ? errors.name : ""}
                            error={touched.name && Boolean(errors.name)}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              if (
                                /^[آ-ی ء چ]+$/.test(e.key) &&
                                e.code !== "Space"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Grid
                            container
                            justifyContent={"center"}
                            alignItems={"center"}
                            gap={1}
                            marginBottom={"8px"}
                          >
                            <Grid item xs={5} width={"100%"}>
                              <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                sx={{ borderRadius: "5px !important" }}
                                disabled={!values.title || !values.name}
                                className={
                                  !values.title || !values.name
                                    ? "btnForm disabledBtn"
                                    : "btnForm SuccessDefault"
                                }
                              >
                                ثبت
                              </Button>
                            </Grid>
                            <Grid item xs={5} width={"100%"}>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{
                                  fontSize: "1rem",
                                  color: "#fff",
                                  height: "40px",
                                  background: "#607D8B",
                                }}
                                sx={{ borderRadius: "5px !important" }}
                                onClick={() => setOpenAddRoleModal(false)}
                              >
                                انصراف
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              </Grid>
            </Box>
          </Modal>
        </div>
      </Grid>
    </>
  );
};

export default RolePermissionList;
